import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './Trend.css';
import { UncontrolledTooltip } from 'reactstrap';
import { calculatePercentage } from '../../Utils/MathUtils';
import moment from 'moment-timezone';
import { trackAnalyticsFeature } from '../../Telemetry/Mixpanel/Features/analyticsTracker';
import { TREND, VALUE_ADD } from '../../Telemetry/Mixpanel/Constants/mixpanelConstants';
class Trend extends Component {
  static contextTypes = {
    t: PropTypes.func.isRequired
  };
  static propTypes = {
    prevStats: PropTypes.shape({
      prevDateRange: PropTypes.shape({
        fromTime: PropTypes.string,
        toTime: PropTypes.string
      }),
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    }),
    currentStats: PropTypes.shape({
      currDateRange: PropTypes.shape({
        fromTime: PropTypes.string,
        toTime: PropTypes.string
      }),
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    }),
    uniqueId: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    mixpanelData: PropTypes.shape({
      action: PropTypes.string.isRequired
    }),
    valuesArePercentages: PropTypes.bool
  };
  render() {
    const { t } = this.context;
    let { currentStats, prevStats, uniqueId, title, mixpanelData, valuesArePercentages } = this.props;

    let prevFromTime = moment(prevStats.prevDateRange.fromTime).format(t('formatting.date'));
    let prevToTime = moment(prevStats.prevDateRange.toTime).format(t('formatting.date'));
    let currentFromTime = moment(currentStats.currDateRange.fromTime).format(t('formatting.date'));
    let currentToTime = moment(currentStats.currDateRange.toTime).format(t('formatting.date'));
    let trendObject = this.getTrendPercentAndAnalysis(currentStats.value, prevStats.value);

    return (
      <div className="trendToolTip trendRow">
        <div
          id={`toolTipTrendData${uniqueId}`}
          className="trendData"
          onMouseEnter={() => trackAnalyticsFeature(VALUE_ADD, mixpanelData.action, TREND)}>
          <i className={`${trendObject.arrowIcon} ${trendObject.arrowColor}`} />
          <span className={`${trendObject.arrowColor}`}>{trendObject.trendPercent}%</span>
        </div>
        <UncontrolledTooltip
          placement="right"
          target={`toolTipTrendData${uniqueId}`}
          className="tooltip-white"
          innerClassName="tooltipInner">
          <section className="tooltipContent">
            <div className="toolTipStats">
              {currentFromTime} - {currentToTime}
            </div>
            <div className="toolTipStats">
              <div>{title}</div>
              <div>
                <b>
                  {currentStats.value} {valuesArePercentages && '%'}
                </b>
              </div>
            </div>

            <div className="trendDivisionLine">
              <span className="vs">{t('trends.versus')}</span>
            </div>

            <div className="divider toolTipStats">
              {prevFromTime} - {prevToTime}
            </div>
            <div className="toolTipStats">
              <div>{title}</div>
              <div>
                <b>
                  {prevStats.value} {valuesArePercentages && '%'}
                </b>
              </div>
            </div>
          </section>
        </UncontrolledTooltip>
      </div>
    );
  }
  getTrendPercentAndAnalysis = (curr, prev) => {
    let trendPercent = calculatePercentage(curr, prev);
    let { arrowIcon, arrowColor } = this.displayTrend(trendPercent);

    trendPercent = Math.abs(trendPercent);
    let trendObject = {
      trendPercent: trendPercent,
      arrowIcon: arrowIcon,
      arrowColor: arrowColor
    };

    return trendObject;
  };

  displayTrend = trendPercent => {
    let arrowColor;
    let arrowIcon = 'togo-icon togo-icon-down-arrow trendIcon';
    let noChangeIcon = 'noChangeIcon';
    if (trendPercent === 0) {
      arrowIcon = noChangeIcon;
      arrowColor = 'blackIcon';
    } else if (trendPercent > 0) {
      arrowIcon = `${arrowIcon} togo-icon-rotate-180`;
      arrowColor = 'greenIcon';
    } else {
      arrowIcon = `${arrowIcon}`;
      arrowColor = 'redIcon';
    }
    return { arrowIcon, arrowColor };
  };
}

export default Trend;



// WEBPACK FOOTER //
// ./src/Components/Trend/Trend.js